module.exports = __webpack_public_path__ + "img/8_ward_150.54f48e10.png";